// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import AboutUs from './components/AboutUs';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import RefundPolicy from './components/RefundPolicy';
import CancellationPolicy from './components/CancellationPolicy';
import FAQ from './components/FAQ';
import ShippingPolicy from './components/ShippingPolicy';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css'; // For global styles
import CopyrightNotice from './components/CopyrightNotice';
import AppDownload from './components/AppDownload';
import usePageTracking from './components/usePageTracking';

function App() {

  usePageTracking();

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/cancellation-policy" element={<CancellationPolicy />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/copyright-notice" element={<CopyrightNotice/>} />
        <Route path="/apps" element={<AppDownload/>} />
        {/* <Route path="/shipping-policy" element={<ShippingPolicy />} /> */}
      </Routes>
      <Footer />
    </>
  );
}

export default App;
